import type { CallSheetDoc } from './types';

/** AI owns manual questions only. Sync-owned data is supplied by the server. */
export function withoutSyncFields(value: Record<string, unknown>): Record<string, unknown> {
  const { scriptMeta: _meta, scriptSyncHealth: _health, ...rest } = value;
  if (Array.isArray(rest.interviewQuestions)) {
    rest.interviewQuestions = rest.interviewQuestions
      .filter((group) => !group || typeof group !== 'object' || (!group.sourceScriptId && !group.internal))
      .map((group) => {
        if (!group || typeof group !== 'object') return group;
        const { internal: _internal, hints: _hints, sourceScriptId: _source, ...manual } = group;
        return manual;
      });
  }
  return rest;
}

/** Preserve all stored synced groups, including their audience, cues and order. */
export function preserveSyncedQuestions(doc: CallSheetDoc, base: CallSheetDoc): CallSheetDoc {
  return {
    ...doc,
    scriptMeta: base.scriptMeta,
    scriptSyncHealth: base.scriptSyncHealth,
    interviewQuestions: [
      ...doc.interviewQuestions,
      ...base.interviewQuestions.filter((group) => group.sourceScriptId || group.internal),
    ],
  };
}
